import { AxiosInstance } from 'axios';
import { GeoJSON } from 'ol/format';
import { NotFound } from '@/domain/NotFound';
import { CountryLabelRepository } from '@/domain/country/CountryLabelRepository';
import { CountryLabel } from '@/domain/country/CountryLabel';
import { StaticFileCountryLabel, toCountryLabelFeature } from '@/secondary/country/StaticFileCountryLabel';
import { Store } from '@/primary/store/Store';

export class StaticFileCountryLabelRepository implements CountryLabelRepository {
  private axiosInstance!: AxiosInstance;
  private store!: Store;
  private promise: Promise<GeoJSON.FeatureCollection<GeoJSON.Point, CountryLabel>> | undefined;

  constructor(axiosInstance: AxiosInstance, store: Store) {
    this.axiosInstance = axiosInstance;
    this.store = store;
    this.promise = undefined;
  }

  private filter(maxRank: number): GeoJSON.FeatureCollection<GeoJSON.Point, CountryLabel> {
    const features = this.store.getCountryLabelFeatureCollection().features.filter(feature => feature.properties.rank <= maxRank);
    return { type: 'FeatureCollection', features };
  }

  private getData(maxRank: number): Promise<GeoJSON.FeatureCollection<GeoJSON.Point, CountryLabel>> {
    return this.axiosInstance
      .get<GeoJSON.FeatureCollection<GeoJSON.Point, StaticFileCountryLabel>>('labels.geojson')
      .then(response => {
        const countryLabelFeatureCollection = { ...response.data, features: response.data.features.map(toCountryLabelFeature) };
        this.promise = undefined;
        this.store.saveCountryLabelFeatureCollection(countryLabelFeatureCollection);
        return this.filter(maxRank);
      })
      .catch(error => {
        throw new NotFound('label').cause(error);
      });
  }

  list(maxRank: number): Promise<GeoJSON.FeatureCollection<GeoJSON.Point, CountryLabel>> {
    if (this.store.getCountryLabelFeatureCollection().features.length > 0) {
      return Promise.resolve(this.filter(maxRank));
    }

    if (!this.promise) {
      this.promise = this.getData(maxRank);
    }

    return this.promise;
  }
}
